import React from "react";
import { Landmark } from "lucide-react";
import { BendaharaSPP } from "@/pages/bendahara/BendaharaSPP";
import { NAV_ORTU } from "@/lib/nav";

function BankInfoCard() {
  return (
    <div
      className="flex items-start gap-3 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-2.5 text-slate-800 shadow-sm max-w-md"
      data-testid="spp-bank-info"
    >
      <Landmark className="w-5 h-5 text-indigo-600 mt-0.5 shrink-0" />
      <div className="leading-tight">
        <div className="text-[11px] uppercase tracking-wider text-indigo-700 font-semibold">
          Pembayaran SPP melalui
        </div>
        <div className="text-sm font-semibold text-slate-900">BANK BNI</div>
        <div className="text-sm font-mono tracking-wide text-slate-900">1178211116</div>
        <div className="text-xs text-slate-600">a.n. SLB Pelita Nusa</div>
      </div>
    </div>
  );
}

export function SPPOrtu() {
  return (
    <BendaharaSPP
      nav={NAV_ORTU}
      canEdit={false}
      showDownload={false}
      pageTitle="Riwayat Pembayaran SPP"
      extraTopAction={<BankInfoCard />}
    />
  );
}
